/* global global */
/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/
class Coverage {
  constructor() {
    this.lines = 0;
    this.executed = 0;
    this.available = true;
    this.calculate();
  }
  
  calculate() {
    var jscoverage = (typeof global === "undefined" ? window : global)._$jscoverage;

    if (typeof jscoverage === "undefined")
      return;

    var that = this;
    Object.values(jscoverage).reduce(function (coverage, data, file) {
      return Object.values(data.lineData).reduce(function (coverage, executions) {
        if (executions === null) return coverage; // line must not be covered, e.g. comments
        return that.add(1, executions > 0 ? 1 : 0);
      }, coverage);
    }, this);

  }

  add(linesOrCoverage, executed) {
    if (linesOrCoverage.lines) {
      this.add(linesOrCoverage.lines, linesOrCoverage.executed);
      return this;
    }
    this.lines += linesOrCoverage;
    this.executed += executed;

    return this;
  }

  summary() {
    return this.percentage().toFixed(2) + "%";
  }
  
  percentage() {
    return this.executed * 100.0 / this.lines;
  }
}

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = Coverage;
}